var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AwlLoader',_vm._b({staticClass:"awl-loader-bouncing"},'AwlLoader',Object.assign({}, _vm.$attrs, _vm.$props),false),[(_vm.$scopedSlots.default || _vm.text)?_vm._t("default",[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }